import { HeaderSideBarContent } from "common";
import ClientUpdateBanner from "features/client-update/ClientUpdateBanner";
import FirstLoginGuard from "features/profile/FirstLoginGuard";
import SessionHandler from "features/profile/SessionHandler";
import WebSocketStatusBanner from "features/websoket/WebSocketStatusBanner";
import { motion } from "framer-motion";
import LayoutStyles2 from "layouts/LayoutStyles2";
import { Outlet, useLocation } from "react-router-dom";
import AdminHeader from "../Admin/AdminHeader";
import PartnerSidebarMenuV2 from "./PartnerSidebarMenuV2";

export default function PartnerLayout() {
  const { pathname } = useLocation();
  return (
    <FirstLoginGuard>
      <LayoutStyles2 />
      <HeaderSideBarContent
        closedWidth={72}
        fullWidthHeader
        drawerProps={{
          sx: {
            [`& div.MuiDrawer-paper`]: {
              borderRight: "none",
            },
          },
        }}
        header={<AdminHeader />}
        //breadcrumbs={<Breadcrumbs items={getMenu(true)} />}
        sidebar={<PartnerSidebarMenuV2 />}
      >
        <motion.div
          className="routeAnimation"
          /*key={pathname}
      initial="initial"
      animate="in"
      variants={pageVariants}
      transition={pageTransition}*/
          //key={pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <ClientUpdateBanner />
          <WebSocketStatusBanner />
          <Outlet />
        </motion.div>
        <SessionHandler />
      </HeaderSideBarContent>
    </FirstLoginGuard>
  );
}
